import { HashRouter as Router, Routes, Route} from 'react-router-dom';
import './app.css';
import Header from '@/components/header/header';
import Footer from '@/components/footer/footer';
import Home from '@/views/home/home';
import Learn from '@/views/learn/learn';
import MdReader from '@/views/mdreader/mdreader';
import Login from '@/views/login/login';
import Chat from '@/views/chat/chat';

function App() {
	return (
		<Router>
			<div className="App">
				<Header />

				<Routes>
					{/* main */}
					<Route path="/" element={<Home />} />

					{/* additional pages */}
					<Route path='/learn' element={<Learn />} />
					<Route path='/learn/articles/' element={<MdReader />} />

					{/* proof-of-concept clinician portal */}
					<Route path='/login' element={<Login />} />
					<Route path='/chat' element={<Chat />} />
				</Routes>

				<Footer />
			</div>
		</Router>
	)
}

export default App;
